<template>
  <ul class="supporting-apps" v-if="allowDebug === true">
    <li>
      <a @click="changeMode('tester')">Activity Tester</a>
    </li>
    <li>
      <a href="preview.html?nid=542">Free Demo/Lesson Preview</a>
    </li>
    <li>
       <router-link to="/unsupported">Unsupported Screen</router-link>
    </li>
  </ul>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

export default {
  computed: {
    ...mapState('application', ['kwtMode', 'allowDebug'])
  },
  methods: {
    ...mapMutations('application', ['setKwtMode']),
    changeMode(mode) {
      this.setKwtMode(mode);
      this.$router.push(mode);
    }
  }
};
</script>

<style lang="scss" scoped>
.supporting-apps {
  list-style: none;
  text-align: center;
  width: 100%;
  margin: auto auto 0;
  padding: 0;
  bottom: 45px;
  li {
    display: inline-block;
    margin-right: 8px;
    a {
      text-decoration: none;
      background-color: white;
      color: black;
      border: 3px solid black;
      border-radius: 5px;
      padding: 2px 10px;
      font-size: 14px;
    }
  }
}
</style>
